import { cx } from "@emotion/css";
import toast, { Toast as RHTToastProps } from "react-hot-toast";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { ToastContent, ToastType } from "../types";

import { createAlertToastStyles } from "./helpers/createAlertToastStyles";

export const AlertToast = ({
  rhtToastProps,
  type,
  content,
}: {
  rhtToastProps: RHTToastProps;
  type: ToastType;
  content: ToastContent;
}) => {
  const classes = createAlertToastStyles(useTheme(), rhtToastProps.position);

  const handleCancelClick = () => {
    toast.dismiss(rhtToastProps.id);
  };
  return (
    <div
      className={cx(
        classes.basic,
        classes[type],
        rhtToastProps.visible ? classes.enter : classes.leave
      )}
      {...rhtToastProps.ariaProps}
    >
      <div className={classes.contentWrapper}>{content}</div>
      <button className={classes.closeButton} onClick={handleCancelClick} />
    </div>
  );
};
